document.addEventListener("DOMContentLoaded", function () {
  function updateScrollbarWidth() {
  const scrollContainer = document.querySelector(".page-wrapper");

  let scrollbarWidth = 0;

  if (scrollContainer) {
    scrollbarWidth =
      scrollContainer.offsetWidth - scrollContainer.clientWidth;
  } else {
    scrollbarWidth =
      window.innerWidth - document.documentElement.clientWidth;
  }

  document.documentElement.style.setProperty(
    "--yu-scrollbar-width",
    Math.max(scrollbarWidth, 0) + "px"
  );
}

updateScrollbarWidth();

window.addEventListener("resize", updateScrollbarWidth, {
  passive: true
});

  const header = document.querySelector("#header-component");

  if (!header) return;

  const menuLinks = header.querySelectorAll(".menu-list__link");
  // The native account component owns a sheet as well as an avatar.
  // Never apply the generic white SVG stroke or movement handler to that host.
  const actionItems = header.querySelectorAll(".header-actions__action:not(.account-button)");
  const logo = header.querySelector(".header-logo");

  function resetMenuLinks() {
    menuLinks.forEach(function (link) {
      const title =
        link.querySelector(".menu-list__link-title") || link;

      link.style.removeProperty("opacity");
      link.style.removeProperty("color");
      link.style.removeProperty("transform");

      title.style.removeProperty("color");
      title.style.removeProperty("transform");
    });
  }

  menuLinks.forEach(function (link) {
    const title =
      link.querySelector(".menu-list__link-title") || link;

    link.addEventListener("mouseenter", function () {
      menuLinks.forEach(function (otherLink) {
        otherLink.style.setProperty("opacity", "0.75", "important");
      });

      link.style.setProperty("opacity", "1", "important");
      link.style.setProperty("color", "#F8F6F2", "important");

      title.style.setProperty("color", "#F8F6F2", "important");
      title.style.setProperty(
        "transform",
        "translateY(-0.75px)",
        "important"
      );
    });

    link.addEventListener("mouseleave", resetMenuLinks);
  });

  actionItems.forEach(function (action) {
    const targets = action.querySelectorAll(
      "cart-icon, .svg-wrapper, svg, path"
    );

    action.addEventListener("mouseenter", function () {
      action.style.setProperty("color", "#F8F6F2", "important");

      targets.forEach(function (target) {
        target.style.setProperty("color", "#F8F6F2", "important");
        target.style.setProperty("stroke", "#F8F6F2", "important");
        target.style.setProperty(
          "transform",
          "translateY(-0.75px)",
          "important"
        );
      });
    });

    action.addEventListener("mouseleave", function () {
      action.style.removeProperty("color");

      targets.forEach(function (target) {
        target.style.removeProperty("color");
        target.style.removeProperty("stroke");
        target.style.removeProperty("transform");
      });
    });
  });

  if (logo) {
    logo.addEventListener("mouseenter", function () {
      logo.style.setProperty("opacity", "0.72", "important");
      logo.style.setProperty(
        "transform",
        "translateY(0) scale(0.96)",
        "important"
      );
    });

    logo.addEventListener("mouseleave", function () {
      logo.style.removeProperty("opacity");
      logo.style.removeProperty("transform");
    });
  }
});

/* ==========================================
   YU SEI — SHOPIFY FORMS EMAIL LABEL
   Deterministic floating-label behaviour
========================================== */

(function () {
  function setupYuSeiEmailForm(embed) {
    if (!embed || !embed.shadowRoot) return;

    const root = embed.shadowRoot;

    const emailInput =
      root.querySelector('input[type="email"]');

    if (!emailInput) return;

    const label =
      root.querySelector(`label[for="${emailInput.id}"]`) ||
      root.querySelector('label');

    if (!label) return;

    if (emailInput.dataset.yuSeiLabelReady === 'true') {
      return;
    }

    emailInput.dataset.yuSeiLabelReady = 'true';


    function updateLabelState() {
      const hasValue =
        emailInput.value.trim().length > 0;

      const isFocused =
        root.activeElement === emailInput;

      const shouldFloat =
        hasValue || isFocused;

      label.classList.toggle(
        'yu-sei-email-label--floating',
        shouldFloat
      );

      label.classList.toggle(
        'yu-sei-email-label--resting',
        !shouldFloat
      );
    }


    emailInput.addEventListener(
      'focus',
      updateLabelState
    );

    emailInput.addEventListener(
      'input',
      updateLabelState
    );

    emailInput.addEventListener(
      'change',
      updateLabelState
    );

    emailInput.addEventListener(
      'blur',
      function () {
        window.requestAnimationFrame(
          updateLabelState
        );
      }
    );


    /*
      Browser autofill can happen after the
      page initially renders, so check a few
      times after load as well.
    */

    updateLabelState();

    setTimeout(
      updateLabelState,
      100
    );

    setTimeout(
      updateLabelState,
      500
    );

    setTimeout(
      updateLabelState,
      1500
    );
  }


  function initialiseYuSeiForms() {
    document
      .querySelectorAll('form-embed')
      .forEach(setupYuSeiEmailForm);
  }


  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialiseYuSeiForms
    );
  } else {
    initialiseYuSeiForms();
  }


  customElements
    .whenDefined('form-embed')
    .then(initialiseYuSeiForms);


  const observer =
    new MutationObserver(
      initialiseYuSeiForms
    );

  observer.observe(
    document.documentElement,
    {
      childList: true,
      subtree: true
    }
  );
})();
/* ==========================================
   YU SEI — NATIVE ACCOUNT AVATAR HOVER
   Lift the closed header avatar only. Reset before activation, then keep it
   still while Shopify's sheet is open. No shadow-root access or icon styling.
========================================== */
(function () {
  'use strict';

  const selector = '#header-component .account-button > shopify-account';
  const states = new WeakMap();
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function eachAccount(root, callback) {
    if (!root || !root.querySelectorAll) return;
    if (root.matches && root.matches(selector)) callback(root);
    root.querySelectorAll(selector).forEach(callback);
  }

  function initialise(account) {
    if (states.has(account)) return;

    const listeners = new AbortController();
    const options = { signal: listeners.signal };
    let hovering = false;
    let sheetOpen = false;
    let suspended = false;

    account.setAttribute('data-yu-account-motion', '');

    function sync() {
      const lift = hovering && !sheetOpen && !suspended &&
        finePointer.matches && !reducedMotion.matches;
      account.toggleAttribute('data-yu-account-hover', lift);
    }

    function restImmediately() {
      suspended = true;
      // No transition on activation: no transformed containing block may be
      // left behind while Shopify positions or paints the native account sheet.
      account.setAttribute('data-yu-account-rest', '');
      account.removeAttribute('data-yu-account-hover');
    }

    function losePointer() {
      hovering = false;
      restImmediately();
    }

    account.addEventListener('pointerenter', function (event) {
      if (event.pointerType !== 'mouse' && event.pointerType !== 'pen') return;
      hovering = true;
      if (!sheetOpen) {
        suspended = false;
        account.removeAttribute('data-yu-account-rest');
      }
      sync();
    }, options);

    account.addEventListener('pointerleave', function () {
      hovering = false;
      sync();
    }, options);

    // Capture runs before the native activation handler. Never prevent the
    // event: Shopify still owns opening, sign-in, consent and navigation.
    account.addEventListener('pointerdown', restImmediately, { ...options, capture: true });
    account.addEventListener('click', restImmediately, { ...options, capture: true });
    account.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') restImmediately();
    }, { ...options, capture: true });

    // Public shopify-account events, including programmatic/editor opening.
    account.addEventListener('open', function () {
      sheetOpen = true;
      restImmediately();
    }, options);

    account.addEventListener('close', function () {
      sheetOpen = false;
      restImmediately();
      // Do not bounce up on close. A new pointer entry rearms the hover.
    }, options);

    states.set(account, {
      pause: losePointer,
      destroy() {
        listeners.abort();
        account.removeAttribute('data-yu-account-motion');
        account.removeAttribute('data-yu-account-hover');
        account.removeAttribute('data-yu-account-rest');
        states.delete(account);
      }
    });
  }

  function setup(root) { eachAccount(root, initialise); }
  function pauseAll() {
    eachAccount(document, account => states.get(account)?.pause());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setup(document), { once: true });
  } else {
    setup(document);
  }

  document.addEventListener('shopify:section:load', event => setup(event.target));
  document.addEventListener('shopify:section:unload', function (event) {
    eachAccount(event.target, account => states.get(account)?.destroy());
  });
  window.addEventListener('blur', pauseAll);
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) pauseAll();
  });
  finePointer.addEventListener('change', pauseAll);
  reducedMotion.addEventListener('change', pauseAll);
})();
